export const MuiInputLabel = {
  styleOverrides: {
    root: {
      fontWeight: 400,
    },
  },
}
